import {createContext, useContext, useState} from "react";

export const OptionCalculatorContext = createContext();

const OptionCalculatorProvider = ({ children }) => {
  const [state, setState] = useState([
    {
      buy_sell: "", // buy or sell
      call_put_stock: "", // call, put, or stock
      strike: "", // strike price
      premium: "", // premium value
    },
  ]);

  return (
    <OptionCalculatorContext.Provider value={{state, setState,}}>
      {children}
    </OptionCalculatorContext.Provider>
  );
};

export default OptionCalculatorProvider;
export function useOptionCalculator () {
  return useContext(OptionCalculatorContext);
}